import Vue from 'vue';
import * as axios from 'axios';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

window.Vue = Vue;

window.axios = axios.create({
    baseURL: process.env.COMMUNITY_API,
});
